import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';

// 管理员邮箱列表（与后端 ADMIN_EMAILS 对应）
const ADMIN_EMAILS = (import.meta.env.VITE_ADMIN_EMAILS || '').split(',').map((s: string) => s.trim()).filter(Boolean);

interface UserMenuProps {
  onNavigate?: (page: 'home' | 'admin') => void;
  currentPage?: string;
}

export function UserMenu({ onNavigate, currentPage }: UserMenuProps) {
  const { user, logout } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);

  if (!user) return null;

  const isAdmin = ADMIN_EMAILS.includes(user.email);

  const getQuotaColor = (quota: number) => {
    if (quota >= 10) return 'text-green-600';
    if (quota >= 5) return 'text-yellow-600';
    if (quota >= 1) return 'text-orange-600';
    return 'text-red-600';
  };

  const getQuotaBgColor = (quota: number) => {
    if (quota >= 10) return 'bg-green-100';
    if (quota >= 5) return 'bg-yellow-100';
    if (quota >= 1) return 'bg-orange-100';
    return 'bg-red-100';
  };

  return (
    <div className="flex items-center space-x-4">
      <div className={`px-4 py-2 rounded-lg ${getQuotaBgColor(user.remaining_quota)}`}>
        <div className="flex items-center space-x-2">
          <span className="text-sm text-gray-600">剩余额度:</span>
          <span className={`font-bold ${getQuotaColor(user.remaining_quota)}`}>
            {user.remaining_quota}
          </span>
        </div>
      </div>

      {isAdmin && onNavigate && currentPage !== 'admin' && (
        <button
          onClick={() => onNavigate('admin')}
          className="text-sm text-blue-600 hover:text-blue-700 font-medium"
        >
          任务管理
        </button>
      )}

      <div className="relative">
        <button
          onClick={() => setShowDropdown(!showDropdown)}
          className="flex items-center space-x-2 text-sm text-gray-700 hover:text-gray-900"
        >
          <span>{user.email}</span>
          <svg className={`w-4 h-4 transition-transform ${showDropdown ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        {showDropdown && (
          <>
            <div className="fixed inset-0 z-10" onClick={() => setShowDropdown(false)} />
            <div className="absolute right-0 top-full mt-1 bg-white border border-slate-200 rounded-lg shadow-lg py-1 z-20 min-w-[120px]">
              <button
                onClick={() => {
                  logout();
                  setShowDropdown(false);
                }}
                className="w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-slate-50"
              >
                登出
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
